// @flow
import * as React from 'react';
import Box from 'components/Box';
import type { Subsite } from 'api/website';
import IncludedSubsites from 'components/IncludedSubsites';
import SearchCategories from 'components/SearchCategories';
import { isEmpty, values, complement } from 'utils/functional';

const SearchFiltersSidebar = ({
  filters,
  searchFacets,
  facetsThatArentLoaded,
  setSearchFilter,
  selectSearchFilterOption,
  deselectSearchFilterOption,
  selectAllSearchFilterOptions,
  subsite
}: {
  filters: SearchFilters,
  searchFacets: Object,
  facetsThatArentLoaded: Array<string>,
  setSearchFilter: Function,
  selectSearchFilterOption: Function,
  deselectSearchFilterOption: Function,
  selectAllSearchFilterOptions: Function,
  subsite: Subsite
}) => {
  const categoriesFacets = values(searchFacets).filter(
    key => key.name === 'categories'
  );
  const loaded = facet =>
    facet.lazy ? !facetsThatArentLoaded.includes(facet.id) : true;
  const hasCategories =
    !isEmpty(categoriesFacets) && !categoriesFacets.some(complement(loaded));
  const hasIncludedSubsites = subsite.includedSubsites.length > 0;
  if (!hasIncludedSubsites && !hasCategories) {
    return null;
  }

  let categoryComponent = null;
  if (hasCategories) {
    const allCategories = categoriesFacets[0];
    const selectedOptions =
      filters[allCategories.id] instanceof Array
        ? filters[allCategories.id]
        : [];
    categoryComponent = (
      <SearchCategories
        facet={allCategories}
        selectedOptions={selectedOptions}
        setSearchFilter={setSearchFilter}
        selectSearchFilterOption={selectSearchFilterOption}
        deselectSearchFilterOption={deselectSearchFilterOption}
        selectAllSearchFilterOptions={selectAllSearchFilterOptions}
      />
    );
  }

  return (
    <Box data-qa-id="search-filters" mb="20px">
      <Box px={0} mt={24}>
        {subsite.includedSubsites.length > 0 ? (
          <IncludedSubsites
            subsites={subsite.includedSubsites}
            parentSubsite={subsite}
          />
        ) : (
          categoryComponent
        )}
      </Box>
    </Box>
  );
};

export default SearchFiltersSidebar;
